// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Ytgo_","left":"styles_left__2ePOd"};